import React from 'react';
import { Jumbotron } from 'reactstrap';

const HomeJumbo = () => {
  return (
    <div>
      <Jumbotron className="JumboTron">
      </Jumbotron>
    </div>
  );
};

export default HomeJumbo;



// WEBPACK FOOTER //
// ./src/components/HomeJumbo.js